import React, { useState } from 'react'

import styled from 'styled-components'

import { Button } from '@nexiahome/ui-common/components/primitives/buttons'
import HelpVideoLink from 'components/HelpVideoLink'

import RequestRemoteAccessModal from 'pages/Customer/RemoteConfiguration/RequestRemoteAccessModal'
import RemoteAccessLinkSystemsModal from 'pages/Customer/RemoteConfiguration/RemoteAccessLinkSystemsModal'

import { screenSize } from 'styles/shared'

import { DeviceBase } from 'types/Device'

type Props = {
  device: DeviceBase
}

const RequestRemoteAccess = ({ device }: Props) => {
  const [showRequestRemoteAccessModal, setShowRequestRemoteAccessModal] = useState(false)
  const [showRemoteAccessLinkSystemsModal, setShowRemoteAccessLinkSystemsModal] = useState(false)
  const isControlHub = device.deviceType === 'control_hub'

  const onClickRemoteRequestAccess = () => {
    if (isControlHub) {
      setShowRemoteAccessLinkSystemsModal(true)
    } else {
      setShowRequestRemoteAccessModal(true)
    }
  }

  return (
    <S.RequestRemoteAccess>
      <Button decoration="secondary" text="REQUEST REMOTE ACCESS" styles={{ button: { height: 'auto', width: '100%', minHeight: 32 } }} onPress={onClickRemoteRequestAccess} />
      {showRequestRemoteAccessModal && (
      <RequestRemoteAccessModal deviceId={device.deviceId}
                                  onCloseCallback={() => setShowRequestRemoteAccessModal(false)}
      />
      )}
      {showRemoteAccessLinkSystemsModal && (
      <RemoteAccessLinkSystemsModal onCloseCallback={() => setShowRemoteAccessLinkSystemsModal(false)} />
      )}

      <HelpVideoLink videoKey={isControlHub ? 'drc_link' : 'drc_xxl'} />
    </S.RequestRemoteAccess>
  )
}

export default RequestRemoteAccess

const S = {
  RequestRemoteAccess: styled.div`
    display: flex;
    flex-direction: column;
    margin: 25px 15px 0px 0px;

    @media ${screenSize.small} {
      margin: 0px;
    }
  `
}
